import { useAppSelector } from '@/shared/hooks';

import { transcriptorModel } from '@/entities/transcriptor';

import * as composedModel from '../model';

// One source of truth for every "Start recording" entry point.
export const useTranscriptorStartAvailability = () => {
  const { funding, isAvailable, canOrder, isReady } = useAppSelector(
    composedModel.selectors.selectTranscriptorAvailability,
  );
  const isRecording = useAppSelector(
    transcriptorModel.selectors.selectIsRecording,
  );
  const isStorageBlocked = useAppSelector(
    composedModel.selectors.selectIsStorageBlocked,
  );

  return {
    funding,
    canStartRecording: isAvailable,
    isStartRecordingDisabled:
      isStorageBlocked || isRecording || !isReady || !canOrder,
    isStorageBlocked,
  };
};
